export default __webpack_public_path__ + "static/Metal_Triangle_Ceiling-1edf0e374faaac23bf3443d34872f1a5.png";